module.exports = __webpack_public_path__ + "media/parallax/separated-leaves-03-d879cdfc.svg";